"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultQuickAmountsSettings = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const format_1 = require("astra-core/utils/format");
const percentValues = [5, 10, 15, 100];
const sumMultipliers = [1, 2, 5, 10];
const getDefaultQuickAmountsSettings = (minBet) => {
    return {
        quickAmountsType: betweb_openapi_axios_1.QuickAmountsType.FixedAmounts,
        fixedAmounts: sumMultipliers.map((multiplier) => (0, format_1.adjustAmountForBackend)(minBet * multiplier)),
        balancePercents: percentValues,
    };
};
exports.getDefaultQuickAmountsSettings = getDefaultQuickAmountsSettings;
//# sourceMappingURL=settings.js.map